// export const BASE_API_URL_ENDPOINT = "http://127.0.0.1/codhod-api/public/v1/";
// export const BASE_API_DOCUMENT = "http://127.0.0.1/codhod-api/public/";
export const BASE_API_URL_ENDPOINT = "https://api.codhod.org/public/v1/";
export const BASE_API_DOCUMENT = "https://api.codhod.org/public/";
// https://api.codhod.org/